<template>
  <div v-if="$route.name === 'CustomFields'">
    <admin-filter
      v-model="filterParams"
    />
    <admin-card>
      <template slot="header">
        Список кастомных полей
        <router-link
          class="pull-right btn btn-primary btn-sm"
          :to="{ name: 'CustomFieldsCreate'}">
          <i class="fa fa-plus"/> Добавить
        </router-link>
      </template>
        <admin-list :items="items" :loading="loading">
          <template slot="headerList">
            <div class="col-6 col-md-4">Название</div>
            <div class="col-6 col-md-2">Код</div>
            <div class="col-6 col-md-2">Сортировка</div>
            <div class="col-6 col-md-3">Управление</div>
          </template>
          <template slot-scope="{ item }">
            <div class="col-6 col-md-4">
              {{item.name}}
            </div>
            <div class="col-6 col-md-2">
              {{item.code}}
            </div>
            <div class="col-6 col-md-2">
              {{item.sort}}
            </div>
            <div class="col-6 col-md-3">
              <router-link
                class="btn btn-primary btn-sm"
                :to="{ name: 'CustomFieldsEdit', params: { id: item.id }}">
                <i class="fa fa-edit"/> Изменить
              </router-link>
            </div>
          </template>
        </admin-list>
      <template slot="footer">
        <admin-pagination
          v-model="page"
          :paginator="itemsPage.paginator"
        />
      </template>
    </admin-card>
  </div>
  <router-view v-else/>
</template>

<script>
  import getCustomFieldsQuery from 'gql/queries/getCustomFields.graphql'
  import AdminCard from '../Components/AdminCard'
  import AdminFilter from '../Components/AdminFilter'
  import AdminList from '../Components/AdminList'
  import AdminPagination from '../Components/AdminPagination'

  export default {
    name: 'CFList',
    components: {AdminPagination, AdminList, AdminFilter, AdminCard},
    computed: {
      items () {
        return this.itemsPage.customFields !== undefined ? this.itemsPage.customFields : []
      }
    },
    data () {
      return {
        showFilter: false,
        loading: false,
        filterParams: [
          {
            name: 'Название',
            code: 'query',
            type: 'text',
            value: null
          },
          {
            name: 'К чему относится',
            code: 'entityType',
            type: 'select',
            value: null,
            multiple: false,
            options: [
              { name: 'Техцентр', value: 'techcenter' },
              { name: 'Заказ', value: 'order' },
              { name: 'Компания', value: 'company' }
            ]
          },
          {
            name: 'Тип поля',
            code: 'type',
            type: 'select',
            value: null,
            multiple: false,
            options: [
              {
                name: 'Флаг',
                value: 'checkbox'
              },
              {
                name: 'Число',
                value: 'number'
              },
              {
                name: 'Текст',
                value: 'text'
              },
              {
                name: 'Текстовая область',
                value: 'textarea'
              }
            ]
          }
        ],
        page: 1,
        itemsPage: {
          paginator: {
            total_count: 1000,
            limit: 10
          }
        }
      }
    },
    apollo: {
      itemsPage: {
        query: getCustomFieldsQuery,
        variables () {
          return {
            page: this.page,
            query: this.filterParams[0].value,
            entityType: this.filterParams[1].value,
            type: this.filterParams[2].value
          }
        },
        fetchPolicy: 'network-only',
        watchLoading (isLoading, countModifier) {
          this.loading = isLoading
        },
        update: (data) => {
          return data
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CFList.vue?2f49c93c